import CustomAlerts from "../components/CustomAlerts/CustomAlerts";

export default function CustomAlertsPage() {
  return (
    <div className="mx-auto max-w-5xl px-4 py-8 md:px-6">
      <CustomAlerts />
    </div>
  );
}
